/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { ProjectRecord } from '@karya/core';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ProjectState = {
  project: ProjectRecord | null;
};

const selectedProjectRaw = localStorage.getItem('project');
const selectedProject = selectedProjectRaw ? (JSON.parse(selectedProjectRaw) as ProjectRecord) : null;

const initialState = {
  project: selectedProject,
} as ProjectState;

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    updateCurrentProject(state, action: PayloadAction<ProjectRecord>) {
      state.project = action.payload;
      const projectRawStr = JSON.stringify(action.payload);
      localStorage.setItem('project', projectRawStr);
    },
    clearCurrentProject(state) {
      state.project = null;
      localStorage.removeItem('project');
    },
  },
});

export const { updateCurrentProject, clearCurrentProject } = projectSlice.actions;
export const projectReducer = projectSlice.reducer;
